import { Box, Typography } from '@mui/material/index';

// Our Components
import Loader from 'components/Loader/index';

function LiablitiesProcessing() {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column'
			}}
		>
			<Typography variant="h1Gascogne">
				Please Do Not Refresh The Page
			</Typography>
			<Typography
				variant="body1"
				sx={{
					marginTop: 5,
					marginBottom: 10
				}}
			>
				Sora is working to display and analyze your existing debt.
			</Typography>
			<Loader size={80} boxSX={{ marginBottom: 10 }} />
		</Box>
	);
}

export default LiablitiesProcessing;
